import {
  FeedbackPrompt,
  GetFeedbackPrompt
} from "../../../types/gqlTypes/graphql"
import { executeQuerySideload } from "../helpers/studyPlan"
import { GET_FEEDBACK_PROMPT } from "./feedbackQueries"

export async function getFeedbackPrompt(
  data: GetFeedbackPrompt
): Promise<FeedbackPrompt> {
  const response = await executeQuerySideload(GET_FEEDBACK_PROMPT, { data })
  return response.feedback.getFeedbackPrompt
}
